import { api } from "../app/api";
import { useAsync } from "../app/useAsync";
import { boolChip, StatusChip } from "../components/StatusChip";

export function HealthPage() {
  const { data, error, loading } = useAsync(api.health, []);

  return (
    <>
      <h1>Health</h1>
      <p className="page-sub">Liveness, environment readiness, and live D1 connectivity.</p>

      {loading && <p className="muted">Loading…</p>}
      {error && <p className="muted">Health endpoint unreachable: {error}</p>}

      {data && (
        <>
          <div className="grid">
            <div className="card">
              <h3>Status</h3>
              <div className="stat">{data.status}</div>
              <p className="muted">{data.service}</p>
            </div>
            <div className="card">
              <h3>Environment</h3>
              <div className="stat" style={{ fontSize: "1.2rem" }}>
                {data.environment}
              </div>
              <p className="muted">{data.service}</p>
            </div>
            <div className="card">
              <h3>Timestamp</h3>
              <div className="stat" style={{ fontSize: "1.1rem" }}>
                {new Date(data.time).toLocaleTimeString()}
              </div>
              <p className="muted">{new Date(data.time).toLocaleDateString()}</p>
            </div>
          </div>

          <div className="card" style={{ marginBottom: "1.2rem" }}>
            <h3>Database</h3>
            <table>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td className="muted">{data.database.name ?? "—"}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>
                    {data.database.connected ? (
                      <StatusChip tone="ok" label="Connected" />
                    ) : (
                      <StatusChip tone="no" label="Not connected" />
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Latency</td>
                  <td className="muted">
                    {data.database.latencyMs != null
                      ? `${data.database.latencyMs}ms`
                      : "—"}
                  </td>
                </tr>
                {data.database.error && (
                  <tr>
                    <td>Error</td>
                    <td className="muted">{data.database.error}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="card">
            <h3>Environment checks</h3>
            <table>
              <tbody>
                <tr>
                  <td>D1 database bound</td>
                  <td>{boolChip(data.checks.database_bound)}</td>
                </tr>
                <tr>
                  <td>D1 database connected</td>
                  <td>{boolChip(data.checks.database_connected)}</td>
                </tr>
                <tr>
                  <td>Shopify store domain set</td>
                  <td>{boolChip(data.checks.shopify_domain_set)}</td>
                </tr>
                <tr>
                  <td>Shopify admin token set</td>
                  <td>{boolChip(data.checks.shopify_token_set)}</td>
                </tr>
                <tr>
                  <td>Shopify API version</td>
                  <td className="muted">
                    {data.checks.shopify_api_version ?? "—"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}
